import { Box, IconButton, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { verify } from '../../utils/common';
import {Container} from "../home/styles";
import {StyledBoxCalendar} from "./styles";
import { Dialog, DialogContent } from "@mui/material";
import NavBar from "../../components/navbar/navbar";
import {Grid} from "./styles";
import Enero from '../../assets/calendario/Enero_Calendario.png';
import Febrero from '../../assets/calendario/Febrero_Calendario.png';
import Marzo from '../../assets/calendario/Marzo_Calendario.png';
import Abril from '../../assets/calendario/ABRIL_Calendario.png';
import Mayo from '../../assets/calendario/mayo_Calendario.png';
import Junio from '../../assets/calendario/Junio_Calendario.png';
import Julio from '../../assets/calendario/julio_Calendario.png';
import Agosto from '../../assets/calendario/agosto_Calendario.png';
import Septiembre from '../../assets/calendario/septiembre_Calendario.png';
import Octubre from '../../assets/calendario/octubre_Calendario.png';
import Noviembre from '../../assets/calendario/noviembre_Calendario.png';
import Diciembre from '../../assets/calendario/diciembre_Calendario.png';
const meses = [
    { name: "Enero", img: Enero },
    { name: "Febrero", img: Febrero },
    { name: "Marzo", img: Marzo },
    { name: "Abril", img: Abril },
    { name: "Mayo", img: Mayo },
    { name: "Junio", img: Junio },
    { name: "Julio", img: Julio },
    { name: "Agosto", img: Agosto },
    { name: "Septiembre", img: Septiembre },
    { name: "Octubre", img: Octubre },
    { name: "Noviembre", img: Noviembre },
    { name: "Diciembre", img: Diciembre },
];

const Calendar: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const [open, setOpen] = React.useState(false);
    const [selectedImage, setSelectedImage] = React.useState<string | null>(null);

    React.useEffect(() => {
        (async () => {
            const currentToken = localStorage.getItem("jwt");
            if (currentToken) {
                const isValid = await verify(currentToken);
                if (isValid.code) {
                    navigate("/unauthorized");
                }
            } else {
                navigate("/unauthorized");
            }
        })();
    }, [navigate]);
    const handleOpenImage = (img: string) => {
        setSelectedImage(img);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedImage(null);
    };

    return (
        <Container>
            <NavBar active="calendar"/>
            <Grid theme={theme}>
                {meses.map((m) => (
                    <StyledBoxCalendar
                        key={m.name}
                        theme={theme}
                        onClick={() => handleOpenImage(m.img)}
                        style={{ cursor: "pointer" }}
                    >
                        <img
                            src={m.img}
                            alt={`Calendario ${m.name}`}
                            style={{
                                width: "100%",
                                display: "block",
                            }}
                        />
                    </StyledBoxCalendar>
                ))}
            </Grid>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="lg"
                fullWidth
            >
                <DialogContent
                    style={{
                        padding: theme.spacing(2),
                        backgroundColor: "#000",
                        textAlign: "center",
                    }}
                >
                    {selectedImage && (
                        <img
                            src={selectedImage}
                            alt="Calendario ampliado"
                            style={{
                                width: "100%",
                                maxHeight: "90vh",
                                objectFit: "contain",
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </Container>
    )
}

export default Calendar;